import { tv } from "tailwind-variants";

export const toggleContainer = tv({
  slots: {
    base: "py-3 font-semibold flex flex-row h-full cursor-pointer  cked:rounded-lg hover:bg-gray-600 gap-1 items-center text-center align-middle  bg-primary-600 peer-checked:!bg-primary-500 peer-checked:cursor-default peer-checked:font-semibold",
  },
  variants: {
    size: {
      sm: {
        base: "px-2",
      },
      md: {
        base: "px-5",
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});
